import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';

/**
 *
 * @returns {ReadOnlyURLSearchParams}
 * @example
 * const searchParams = useSearchParams();
 * const value = searchParams.get('key');
 * searchParams.append('key', 'value');
 * searchParams.set('key', 'value');
 * searchParams.delete('key');
 * searchParams.sort();
 */
function useSearchParams() {
    const { search } = useLocation();

    return useMemo(() => new URLSearchParams(search), [search]);
}

export default useSearchParams;
